module.exports = __webpack_public_path__ + "static/media/bg2.8a015c35.jpg";